// Reliance : adresse de ce fichier, pour charger l'aperçu rapide (rel-quickview) depuis le même dossier.
// Variables globales en var : le fichier peut être inclus par plusieurs sections de la même page.
var relQuickAddSrc = relQuickAddSrc || (document.currentScript ? document.currentScript.src : '');
var relQuickviewLoading = relQuickviewLoading || null;

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      // opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          // Reliance : les fiches de la refonte (rel-main-product, ou sans section MainProduct) n'ont pas
          // le sélecteur de variantes Dawn attendu plus bas → aperçu rapide à la place
          if (!this.productElement || !this.productElement.querySelector('variant-radios, variant-selects')) {
            return this.openRelQuickview(opener);
          }
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          // opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // Ouvre l'aperçu rapide Reliance (assets/rel-quickview.js : choix du format, ajout au panier),
    // chargé à la demande s'il n'est pas déjà sur la page ; sinon, repli sur la fiche produit.
    openRelQuickview(opener) {
      const url = opener.getAttribute('data-product-url') || '';
      const match = url.match(/\/products\/([^/?#]+)/);
      if (!match) return;
      const handle = decodeURIComponent(match[1]);
      const closeButton = this.querySelector('.quick-add-modal__toggle');
      if (closeButton && !opener.hasAttribute('data-rel-qv-close-label')) {
        opener.setAttribute('data-rel-qv-close-label', closeButton.getAttribute('aria-label') || '');
      }

      return this.loadRelQuickview()
        .then(() => window.relQuickview.open(handle, opener))
        .catch(() => {
          window.location.href = url;
        });
    }

    loadRelQuickview() {
      if (window.relQuickview && window.relQuickview.open) return Promise.resolve();
      if (!relQuickAddSrc) return Promise.reject();
      if (!relQuickviewLoading) {
        relQuickviewLoading = new Promise((resolve, reject) => {
          const css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = relQuickAddSrc.replace('quick-add.js', 'rel-quickview.css');
          document.head.appendChild(css);

          const script = document.createElement('script');
          script.src = relQuickAddSrc.replace('quick-add.js', 'rel-quickview.js');
          script.onload = () => (window.relQuickview && window.relQuickview.open ? resolve() : reject());
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      return relQuickviewLoading;
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}



